import MuiLink, { LinkProps as MuiLinkProps } from '@mui/material/Link';
import React from 'react';

import { toSxArray } from '_lib/utils/helpers';

import type { OverrideProperties } from 'type-fest';

export type LinkProps = {
  children?: MuiLinkProps['children'];
  component?: MuiLinkProps['component'];
  color?: MuiLinkProps['color'];
  href?: MuiLinkProps['href'];
  onClick?: MuiLinkProps['onClick'];
  rel?: MuiLinkProps['rel'];
  /**
   * @default
   *{ cursor: 'pointer' }
   */
  sx?: MuiLinkProps['sx'];
  target?: MuiLinkProps['target'];
  /** @default 'hover' */
  underline?: MuiLinkProps['underline'];
  /** @default 'body1' */
  variant?: MuiLinkProps['variant'];
};

export const Link = (props: LinkProps) => {
  const { sx, color, underline, ...restOfProps } = props;
  return (
    <MuiLink
      sx={[(theme) => ({ color: color ? undefined : theme.palette.primary.dark, cursor: 'pointer' }), ...toSxArray(sx)]}
      underline={underline || 'hover'}
      color={color}
      {...restOfProps}
    />
  );
};

type ExternalLinkProps = OverrideProperties<
  LinkProps,
  {
    href: MuiLinkProps['href'];
    /** @default 'noreferrer' */
    rel?: MuiLinkProps['rel'];
    /** @default '_blank' */
    target?: MuiLinkProps['target'];
    /** @default 'always' */
    underline?: MuiLinkProps['underline'];
  }
>;

export const ExternalLink = (props: ExternalLinkProps) => {
  return <Link rel='noreferrer' target='_blank' underline='always' {...props} />;
};
